import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Users"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold fs-7" }, "Active/New users by month")
  ])
], -1)
const _hoisted_3 = { id: "chart" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(), _createElementBlock("div", {
      class: "card-body",
      key: _ctx.key
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_apexchart, {
          type: "area",
          height: "350",
          options: _ctx.chart.options,
          series: _ctx.chart.data
        }, null, 8, ["options", "series"])
      ])
    ]))
  ]))
}